module.exports = __webpack_public_path__ + "img/shoppingCar.022f560a.svg";